import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Components/Common/Breadcrumb";
import Input from "../../Components/Common/Input";
import useToastError from "../../hooks/useErrorToast";
import Button from "../../Components/Common/Button";
import { useAuth } from "../../Context/AuthContext";
import useSWRMutation from "swr/mutation";
import { UserApiUrls } from "../../Api/Auth/ApiUrls";
import { sendDeleteRequestAuth, sendPutRequestAuth } from "../../Api/swrConfig";
import { toast } from "react-toastify";
import { useAlert } from "../../Context/AlertContext";

const Profile = () => {
  const { userData, setUserData, mutate } = useAuth();
  const [selectedCard, setSelectedCard] = useState(null);
  const [formData, setFormData] = useState({
    name: userData.name || "",
    email: userData.email || "",
    oldPassword: "",
    password: "",
    confirmPassword: "",
    organization: userData.organization || "",
  });
  const [errors, setErrors] = useState({});
  const { showErrorToast } = useToastError();
  const { showAlert, setIsLoading } = useAlert();

  useEffect(() => {
    mutate();
  }, [mutate]);

  const handleInputChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const { trigger, isMutating } = useSWRMutation(
    UserApiUrls.edit(userData._id),
    sendPutRequestAuth,
    {
      onSuccess: (data) => {
        const userData = data?.user;
        if (!userData) {
          return;
        }
        toast.success("Success");
        setUserData((prev) => ({
          ...prev,
          name: userData.name,
          email: userData.email,
          organization: userData.organization,
        }));
      },
      onError: (error) => {
        console.log(error);

        showErrorToast(error);
        // console.log(error);
      },
    }
  );

  const { trigger: deleteTrigger } = useSWRMutation(
    selectedCard
      ? UserApiUrls.deleteCards(userData._id, selectedCard.id)
      : null,
    sendDeleteRequestAuth,
    {
      onSuccess: () => {
        setIsLoading(false);
        toast.success("Success");
        mutate();
      },
      // If error occurred - make delete false
      onError: (error) => {
        setIsLoading(false);
        showErrorToast(error);
      },
    }
  );
  const onRemove = async (card) => {
    setSelectedCard(card);

    showAlert(
      `Are you sure you want to delete the card ending with ${card?.card.last4}?`,
      async () => {
        setIsLoading(true);
        await deleteTrigger();
      }
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simple validation
    const validationErrors = {};
    if (!formData.name) validationErrors.name = "Name is required.";
    if (!formData.email) validationErrors.email = "Email is required.";
    if (!formData.oldPassword)
      validationErrors.oldPassword = "Old Password is required.";
    if (!formData.password) validationErrors.password = "Password is required.";
    if (!formData.confirmPassword)
      validationErrors.confirmPassword = "Confirm password is required.";
    else if (formData.confirmPassword !== formData.password)
      validationErrors.confirmPassword = "Passwords do not match.";
    if (!formData.organization)
      validationErrors.organization = "Organization is required.";
    setErrors(validationErrors);
    // Handle form submission if there are no errors
    if (Object.keys(validationErrors).length !== 0) {
      return;
    }
    const modifiedData = { ...formData };
    delete modifiedData.confirmPassword;
    trigger(modifiedData);
  };
  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <h2 className="font-regular mb-4">View/Edit your profile</h2>
      <div className="space-y-2">
        <Input
          label="Name"
          type="text"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          placeholder="Enter your name"
          error={errors.name}
          required
        />
        <Input
          label="Email"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          placeholder="Enter your email"
          error={errors.email}
          required
        />
        <Input
          label="Old Password"
          type="password"
          name="oldPassword"
          value={formData.oldPassword}
          onChange={handleInputChange}
          placeholder="Enter your old password"
          error={errors.oldPassword}
          required
        />
        <Input
          label="Password"
          type="password"
          name="password"
          value={formData.password}
          onChange={handleInputChange}
          placeholder="Enter your password"
          error={errors.password}
          required
        />
        <Input
          label="Confirm Password"
          type="password"
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleInputChange}
          placeholder="Confirm your password"
          error={errors.confirmPassword}
          required
        />
        <Input
          label="Organization/University/Institute/Others"
          type="text"
          name="organization"
          value={formData.organization}
          onChange={handleInputChange}
          placeholder="Enter your organization"
          error={errors.organization}
          required
        />
        <Button onClick={handleSubmit} type="primary" isLoading={isMutating}>
          Submit
        </Button>
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 mt-4">
        {userData?.cards.map((card) => (
          <div
            key={card.id}
            className="bg-white shadow-md rounded-xl p-4 flex flex-col justify-between border hover:shadow-lg transition"
          >
            <div>
              <div className="flex items-center justify-between mb-2">
                <div className="text-lg font-semibold capitalize">
                  {card.card.brand} **** {card.card.last4}
                </div>
                <div className="text-sm text-gray-500">{card.card.country}</div>
              </div>
              <div className="text-sm text-gray-600">
                Expires: {card.card.exp_month}/{card.card.exp_year}
              </div>
            </div>

            <button
              onClick={() => onRemove(card)}
              className="mt-4 text-red-600 border border-red-600 hover:bg-red-600 hover:text-white transition rounded px-4 py-2 text-sm"
            >
              Remove Card
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Profile;
